import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from 'react-redux'
import { useAppSelector } from "redux-share";
import dynamic from "next/dynamic";
import LiveStatus from "../../player-components/liveStatus/liveStatus";

const Poll = dynamic(() => import("../../player-components/poll/poll"));
const Lock = dynamic(() => import("../../player-components/lockUnlock/lock"));
const Unlock = dynamic(() => import("../../player-components/lockUnlock/unlock"));
const Title = dynamic(() => import("../../player-components/title/title"));
const Snapshot = dynamic(() => import("../../player-components/snapshot/snapshot"));
const FullRate = dynamic(() => import("../../player-components/fullrate/fullrate"));
const AgeClassification = dynamic(() => import("../../player-components/ageClassification/ageClassification"));

const Header = () => {

    useAppSelector(({ controller: { lock, activeElements } }) => ({ lock, activeElements }), shallowEqual);

    return (
        <div className="pl-flex pl-items-center pl-justify-between pl-mt-3 pl-mx-3">
            {conditions(ConditionName.showLiveStatus) && <LiveStatus />}
            {conditions(ConditionName.showPoll) && <Poll />}
            {conditions(ConditionName.isLock) && <Lock className={`pl-cursor-pointer pl-relative animate__animated animate__faster ${conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"}`}/>}
            {conditions(ConditionName.showUnlockIconInHeader) && <Unlock />}
            {conditions(ConditionName.showTitle) && <Title />}
            {conditions(ConditionName.showSnapShot) && <Snapshot />}
            {conditions(ConditionName.showFullRate) && <FullRate />}
            {conditions(ConditionName.showAgeClassification) && <AgeClassification />}
        </div>
    )
}

export default Header;